import { Battery, Mic } from "lucide-react";
import { seg } from "./primitives";

const pad = (n) => String(Math.floor(n)).padStart(2, "0");

export function StageFilm({ p }) {
  const secs = seg(p, 0.05, 0.85) * 28;
  const saved = p > 0.82;
  return (
    <div className="relative h-full w-full overflow-hidden rounded-2xl border border-white/10 bg-black">
      <img src="/images/re-agent-sign.jpg" alt="Example: filming a realtor in front of a home for sale" loading="lazy"
        className="absolute inset-0 h-full w-full object-cover" style={{ transform: `scale(${1.15 - seg(p, 0, 1) * 0.12})` }} />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/5 to-black/60" />
      <div className="absolute inset-0 grid grid-cols-3 grid-rows-3">
        {Array.from({ length: 9 }).map((_, i) => <div key={i} className="border border-white/[0.09]" />)}
      </div>
      {["left-5 top-5 border-l-2 border-t-2", "right-5 top-5 border-r-2 border-t-2", "left-5 bottom-5 border-l-2 border-b-2", "right-5 bottom-5 border-r-2 border-b-2"].map((c) => (
        <span key={c} className={`absolute h-8 w-8 border-white/80 ${c}`} />
      ))}
      <div className="absolute left-1/2 top-1/2 h-20 w-20 -translate-x-1/2 -translate-y-1/2 border border-amber-300/90" style={{ opacity: p > 0.1 ? 1 : 0.3 }} />

      <div className="absolute left-8 top-8 flex items-center gap-2 rounded-md bg-black/60 px-2.5 py-1.5 font-mono text-xs text-white">
        <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" /> REC
        <span className="tabular-nums">00:00:{pad(secs)}:{pad((secs % 1) * 24)}</span>
      </div>
      <div className="absolute right-8 top-8 flex items-center gap-3 font-mono text-[11px] text-white/90">
        <span>4K · 60fps</span><span className="hidden sm:inline">ISO 400</span><Battery className="h-4 w-4" />
      </div>

      <div className="absolute bottom-8 left-8 flex items-end gap-3">
        <Mic className="h-4 w-4 text-white/80" />
        {[0, 1].map((ch) => (
          <div key={ch} className="flex h-16 gap-[3px]">
            {Array.from({ length: 6 }).map((_, i) => (
              <span key={i} className="w-[5px] origin-bottom animate-eq rounded-sm bg-gradient-to-t from-emerald-400 via-emerald-300 to-amber-300"
                style={{ animationDelay: `${(i * 0.13 + ch * 0.27) % 0.9}s`, height: "100%" }} />
            ))}
          </div>
        ))}
      </div>
      <div className="absolute bottom-8 right-8 text-right font-mono text-[11px] text-white/85">
        <p>TAKE 03 · SCENE 2</p><p className="text-white/60">Example · Listing walkthrough</p>
      </div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-16 rounded-full bg-emerald-500/90 px-4 py-2 text-xs font-semibold text-white shadow-lg transition-[opacity,transform] duration-500"
        style={{ opacity: saved ? 1 : 0, transform: `translate(-50%, ${saved ? 64 : 80}px)` }}>
        Clip saved → Sending to edit
      </div>
    </div>
  );
}
